import classNames from 'classnames/bind';
import { Dispatch } from 'react';

import styles from './Filter.module.scss';
import { FILTER_VALUES } from './types';

const cx = classNames.bind(styles);

export interface FilterOption {
    label: string;
    value: FILTER_VALUES;
}

interface FilterProps {
    selected: FILTER_VALUES;
    setSelected: Dispatch<FILTER_VALUES>;
}

const FILTER_OPTIONS: FilterOption[] = [
    { label: '6M', value: FILTER_VALUES.LAST_SIX_MONTHS },
    { label: '1Y', value: FILTER_VALUES.LAST_TWELVE_MONTHS },
    { label: 'All', value: FILTER_VALUES.ALL_TIME },
];

export default function Filter({ selected, setSelected }: FilterProps) {
    return (
        <div className={styles.filterWrapper}>
            {FILTER_OPTIONS.map(({ label, value }) => {
                return (
                    <button
                        className={cx('filter', {
                            'filter--selected': selected === value,
                        })}
                        key={value}
                        onClick={() => setSelected(value)}
                        type="button"
                    >
                        {label}
                    </button>
                );
            })}
        </div>
    );
}
